module.exports = __webpack_public_path__ + "img/28.d9265d85.jpg";